import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import googlePlay from "../assets/google-play.png";
import appStore from "../assets/app-store.svg";
import { CenterOnPage } from "../core/CenterOnPage";
import Button from "@mui/material/Button";

const APP_STORE_LINK = "https://apps.apple.com/au/app/pitch2table/id6560116374";
const PLAY_STORE_LINK = "https://play.google.com/store/apps/details?id=com.pitch2table.app";

/**
 * Fallback page when the mobile app auth callback lands in a browser
 * (e.g. user on desktop, or app not installed).
 * On mobile with app installed, Universal Links intercept before this loads.
 * This should never be seen in a browser.
 */
export const LoginMobPage = () => {
  return (
    <CenterOnPage>
      <Box p={2} maxWidth="66ch">
        <Card>
          <Box p={2}>
            <Box pb={2}>
              <Typography textAlign="center" variant="h4">
                Get Pitch2Table on Mobile
              </Typography>
            </Box>
            <Box pt={2}>
              <Typography>
                Pitch2Table is on iOS and Android. You can get it from the App Store or Google Play. The mobile app has
                all the same features in a portable format. Always be ready for the pitch!
              </Typography>
            </Box>
            <Box pt={2} display="flex" flexDirection="row" gap={1} alignItems="center">
              <a href={APP_STORE_LINK} target="_blank" rel="noreferrer">
                <img src={appStore} alt="download from the App Store" style={{ width: "auto", height: 44 }} />
              </a>
              <a href={PLAY_STORE_LINK} target="_blank" rel="noreferrer">
                <img src={googlePlay} alt="download from Google Play" style={{ width: "auto", height: 44 }} />
              </a>
              <Button variant="contained" href="https://app.pitch2table.com">
                Login in on Web
              </Button>
            </Box>
          </Box>
        </Card>
      </Box>
    </CenterOnPage>
  );
};
